import React from 'react';
import { useTranslation } from 'react-i18next';
import { useCartData } from '../../../hooks/order';
import PaymentMethodSelector from './PaymentMethodSelector';
import CartInformation from '../../common/CartInformation';
import ChargeBreakdown from './ChargeBreakdown';

// Order: Charge Breakdown (mobile/tablet - desktop has the cart in the sidebar)
// -> Payment Method (with its own Terms/APA consent and Place Order, which validates the payment
// and submits the order). There's no separate legacy Terms step here. Installation Information
// renders after this whole section, as its own block at the bottom of the page - see
// SinglePageCheckout.js.
const ReviewPaySection = ({
  activeKey,
  setActiveKey,
  paymentPanelKey,
  tcPanelKey,
  submitOrderRef,
  showMiniCart,
}) => {
  const { t } = useTranslation();
  const { getOneTimeChargesHeadingValue } = useCartData();

  // tcPanelKey (the legacy Terms step's key) still counts as this section being open, showing
  // the same payment form - the legacy Terms step isn't rendered in the SPC.
  const isActive = activeKey === paymentPanelKey || activeKey === tcPanelKey;
  const isDone = parseInt(activeKey, 10) > parseInt(tcPanelKey, 10);
  // activeKey is only ever non-empty once a plan has been confirmed - before that, this
  // header must stay inert so this step can't be opened ahead of plan selection.
  const isInteractive = Boolean(activeKey);

  return (
    <div className={`spc-card spc-review-pay-section ${isActive ? 'is-expanded' : 'is-collapsed'}`}>
      <div
        className={`spc-card__collapsed-row ${isInteractive ? 'spc-card__collapsed-row--clickable' : ''}`}
        onClick={() => isInteractive && setActiveKey(paymentPanelKey)}
      >
        <h3 className="spc-section-title">{t('singlePageCheckout.reviewAndPay')}</h3>
        {isDone && <span className="spc-collapsed-summary">{t('common.confirm')}</span>}
      </div>

      {showMiniCart && isActive && (
        <>
          <ChargeBreakdown />
          {/* Mounted only for the order-submission handler it publishes to submitOrderRef. */}
          <div className="spc-hidden-cart" aria-hidden="true">
            <CartInformation setActiveKey={setActiveKey} submitOrderRef={submitOrderRef} isSpc />
          </div>
        </>
      )}

      {isActive && (
        <>
          {!showMiniCart && (
            <div className="spc-due-today-bar">
              <span>{t('fixedFooter.dueToday')}</span>
              <span className="spc-due-today-bar__amount">{getOneTimeChargesHeadingValue()}</span>
            </div>
          )}
          <PaymentMethodSelector activeKey={activeKey} setActiveKey={setActiveKey} submitOrderRef={submitOrderRef} />
        </>
      )}
    </div>
  );
};

export default ReviewPaySection;
